<template>
  <div v-if="mailingAddress != null" class="">
    
    <div class="mt-12 text-sm overflow-hidden">
      <div class="float-left text-base uppercase font-semibold text-gray-700">
        Mailing Address
      </div>

      <div class="float-left ml-8">
        <input type="checkbox" v-on:change="makeSameAsResidential($event.target.checked)" id="inputMailIssame_as_residential" />
        <label for="inputMailIssame_as_residential" class="ml-2">Mailing address is same as residential</label>
      </div>
    </div>

    <div class="label-line flex flex-wrap">
      <div class="w-full lg:w-1/3 pr-0 lg:pr-3 flex flex-wrap">
        <div class="w-1/3 pr-2">
          <BuildingTypeSelector
            propertyKey="building_type"
            objectType="address"
            :value="mailingAddress.building_type"
            :updateValue="updateValue" />
        </div>

        <div class="w-1/3 pr-2">
          <InputText 
            label="Unit number"
            propertyKey="unit_number"
            objectType="address"
            :value="mailingAddress.unit_number"
            :updateValue="updateValue" />
        </div>

        <div class="w-1/3">
          <InputText 
            label="Street number"
            propertyKey="street_number"
            objectType="address"
            :value="mailingAddress.street_number"
            :updateValue="updateValue" />
        </div>
      </div>

      <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0 flex flex-wrap">
        <div class="w-3/4 pr-2">
          <InputText 
            label="Street name"
            propertyKey="street_name"
            objectType="address"
            :value="mailingAddress.street_name"
            :updateValue="updateValue" />

          <div class="mt-1 text-right" v-if="mailingAddress.street_name != null && mailingAddress.street_name.length > 0">
            <a href="#" class="text-gray-700 hover:underline" @click.prevent="$modal.show('map-modal', { 
              address : getAddressText() 
            })">Show this address on map</a>
          </div>
        </div>

        <div class="w-1/4 pl-1">
          <StreetTypeSelector
            propertyKey="street_type"
            objectType="address"
            :value="mailingAddress.street_type"
            :updateValue="updateValue" />
        </div>
      </div>

      <div class="w-full lg:w-1/3 mt-8 lg:mt-0">
        <InputText 
          label="Suburb"
          propertyKey="suburb"
          objectType="address"
          :value="mailingAddress.suburb"
          :updateValue="updateValue" />          
      </div>
    </div>

    <div class="flex flex-wrap label-line">
      <div class="w-full lg:w-1/3 pr-0 lg:pr-3">
        <InputPostcode 
          label="Postcode"
          propertyKey="postcode"
          objectType="address"
          :value="mailingAddress.postcode"
          :updateValue="updateValue" />
      </div>

      <div class="w-full lg:w-1/3 pr-0 lg:pr-3" ref="stateSelector">
        <StateSelector
          propertyKey="state_id"
          objectType="address"
          :value="mailingAddress.state_id"
          :updateValue="updateValue" />
      </div>

      <div class="w-full lg:w-1/3 pr-0 lg:pr-3" ref="countrySelector">
        <CountrySelector
          propertyKey="country_id"
          objectType="address"
          :value="mailingAddress.country_id"
          :updateValue="updateValue" />
      </div>
    </div>
          
  </div>
</template>

<script>
  import axios                from 'axios'
  import moment               from 'moment'
  import InputText            from '@/shared/components/form/InputText'
  import InputPostcode        from '@/shared/components/form/InputPostcode'
  import StreetTypeSelector   from '@/shared/components/form/StreetTypeSelector'
  import StateSelector        from '@/shared/components/form/StateSelector'
  import CountrySelector      from '@/shared/components/form/CountrySelector'
  import BuildingTypeSelector from '@/shared/components/form/BuildingTypeSelector'
  
  export default {

    props : {
      currentAddress : {
        type    : Object,
        required: false
      }
    },

    components: {
      InputText,
      StateSelector,
      CountrySelector,
      InputPostcode,
      StreetTypeSelector,
      BuildingTypeSelector
    },

    data() {
      return {
        mailingAddress : null,
      }
    },

    created() {
      this.getData()
    },

    methods : {

      makeSameAsResidential(trueOrFalse) {
        if(trueOrFalse) {
          this.mailingAddress.unit_number   = this.currentAddress.address.unit_number
          this.mailingAddress.street_number = this.currentAddress.address.street_number
          this.mailingAddress.street_name   = this.currentAddress.address.street_name
          this.mailingAddress.street_type   = this.currentAddress.address.street_type
          this.mailingAddress.suburb        = this.currentAddress.address.suburb
          this.mailingAddress.postcode      = this.currentAddress.address.postcode
          this.mailingAddress.state_id      = this.currentAddress.address.state_id
          this.mailingAddress.country_id    = this.currentAddress.address.country_id
          
          // save the whole thing
          this.updateAddress(this.mailingAddress)
        }
      },

      getData() {
        this.apiGet({
          clientId   : this.$route.params.clientId,
          applicantId: this.$route.params.applicantId          
        }, 'address/mailing-address', (mailingAddress) => {
          this.hideLoader()
          this.mailingAddress = mailingAddress          
        })
      },

      // a method that will receive the value and update
      updateValue(params) {
        this.updateAddress(this.mailingAddress, params.key, params.value)
      },
    }
  }
</script>